import script from "./RepaymentTypeSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./RepaymentTypeSelection.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/professional-grad/loanConfiguration.css?vue&type=style&index=0&id=e121c736&scoped=true&lang=css"
import "@/styles/professional-grad/button.css?vue&type=style&index=1&id=e121c736&scoped=true&lang=css"
import "@/styles/professional-grad/substep-4.css?vue&type=style&index=2&id=e121c736&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e121c736"]])

export default __exports__